module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "6562.e52159a6.jpg";